module.exports = __webpack_public_path__ + "static/media/cq_ko b.8d137703.svg";